<template>
  <div
    class="item"
    :class="[
      theme === 'gray' && 'item--gray',
      theme === 'white' && 'item--white',
      size === 'big' && 'item--big',
      noContent && 'item--nocontent',
    ]"
  >
    <div class="drag-handle" v-if="draggable">
      <img src="/resources/images/drag-icon.svg" alt="Drag handle" />
    </div>
    <div class="item__header">
      <div>
        <span class="item__title" v-if="title">{{ title }}</span>
        <slot v-else name="title" />
      </div>
      <div class="item__controls">
        <slot name="actions" />
        <div v-if="hasControls" class="item__controls-group">
          <a-button
            class="item__button"
            type="link"
            size="small"
            title="Move down"
            @click="() => $emit('moveDown', index)"
            :disabled="isLast"
          >
            <a-icon type="down" />
          </a-button>
          <a-button
            type="link"
            size="small"
            title="Move to bottom"
            @click="() => $emit('moveBottom', index)"
            :disabled="isLast"
          >
            <a-icon type="double-right" style="transform: rotate(90deg)" />
          </a-button>
        </div>
        <div v-if="hasControls" class="item__controls-group">
          <a-button
            type="link"
            size="small"
            title="Move up"
            @click="() => $emit('moveUp', index)"
            :disabled="isFirst"
          >
            <a-icon type="up" />
          </a-button>
          <a-button
            type="link"
            size="small"
            title="Move to top"
            @click="() => $emit('moveTop', index)"
            :disabled="isFirst"
          >
            <a-icon type="double-right" style="transform: rotate(-90deg)" />
          </a-button>
        </div>
        <a-button
          v-if="hasDelete"
          type="link"
          size="small"
          title="Remove"
          @click="() => $emit('remove', index)"
        >
          <a-icon type="delete" style="color: #ff4d4f" />
        </a-button>
      </div>
    </div>
    <div v-if="hasDefaultSlot" class="item__content">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    draggable: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'white',
    },
    size: {
      type: String,
    },
    title: {
      type: String,
    },
    index: {
      type: Number,
    },
    isLast: {
      type: Boolean,
      default: true,
    },
    isFirst: {
      type: Boolean,
      default: true,
    },
    hasDelete: {
      type: Boolean,
      default: true,
    },
    hasControls: {
      type: Boolean,
      default: true,
    },
    noContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots?.default
    },
  },
}
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: column;
  // gap: 10px;
  position: relative;
  padding: 12px;

  &--nocontent .item__content {
    margin-top: 0 !important;
  }

  &--big {
    padding: 16px 24px;

    .item__content {
      margin-top: 32px;
    }
  }

  &--white {
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
  }

  &--gray {
    background-color: #fafafa;
    box-shadow: 0 1px 4px 0 #0c0c0d1a;
    padding: 10px 16px;
  }

  ::v-deep .ant-form-item {
    margin: 0;
  }

  ::v-deep .anticon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.item__header {
  display: flex;
  justify-content: space-between;
}

.item__title {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}

.item__controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;

  ::v-deep .ant-btn {
    padding: 0;
    width: 20px;
    height: 20px;
  }
}

.item__controls-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.item__content {
  margin-top: 12px;
}

.drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  padding: 6px 3px 5px 2px;
  left: -10px;
  top: 0;
  z-index: 0;
  background-color: #fafafa;
  cursor: pointer;

  img {
    height: 10px;
    width: auto;
    pointer-events: none;
    user-select: none;
  }
}
</style>
